import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { decisionGaps } from '../../data/content';
import { SectionCTA } from '../SectionCTA';
export function KnowledgeSection() {
  return <section className="w-full bg-cream px-4 py-16 sm:px-6 sm:py-20" data-id="element-237" data-mp="8kp9dzg5uir9">
      <div className="mx-auto max-w-3xl" data-id="element-238" data-mp="8m0afri81ceo">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink-muted" data-id="element-239" data-mp="3kt6y4n42zdt">
          The problem isn’t always a lack of knowledge
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-240" data-mp="371t8emmicbsl">
          It’s not knowing how to turn what you know into a{' '}
          <em className="text-navy-600" data-id="element-241" data-mp="3lwzbp1u7xwi8">workflow</em>
        </h2>

        <div className="mt-8 space-y-2.5" data-id="element-242" data-mp="3gz688gkavgln">
          {['You’ve studied occlusion.', 'You’ve learned about VDO, function, records and rehabilitation.', 'You’ve attended courses, read books and gained clinical experience.'].map(line => <p key={line} className="rounded-xl bg-white px-4 py-3 text-[15px] font-medium text-ink shadow-soft" data-id="element-243" data-mp="tv3fhu5qw0kz">
              {line}
            </p>)}
        </div>

        <p className="mt-8 text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-244" data-mp="13uuary24qjm4">
          But when a complex case sits in your chair, information doesn’t automatically become a
          sequence. You still have to decide:
        </p>

        <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-245" data-mp="g4rlfpplnrr7">
          {decisionGaps.map(gap => <li key={gap} className="flex items-center gap-2.5 rounded-xl border border-navy-100 bg-white px-4 py-3 text-[15px] font-semibold text-navy-700" data-id="element-246" data-mp="k6d6hycafcch">
              <HelpCircleIcon className="h-4 w-4 shrink-0 text-navy-400" aria-hidden="true" data-id="element-247" data-mp="3okjp89yx83ea" />
              {gap}
            </li>)}
        </ul>

        <p className="mt-8 rounded-2xl bg-navy-700 px-5 py-5 text-center font-display text-lg italic leading-snug text-white sm:text-xl" data-id="element-248" data-mp="3sku2m7p1lw36">
          Without a repeatable workflow, every complex case can feel like you’re rebuilding your
          process from zero.
        </p>

        <SectionCTA transformation="Stop rebuilding your process from zero on every case." label="I want a structured DVO workflow" subline="Lifetime access · 7-day money-back guarantee" data-id="element-249" data-mp="19hrbla8uocyk" />
      </div>
    </section>;
}